<template>
  <div class="component-wrapper d-flex flex-column align-center pa-5">
    <img class="logo mb-4" src="@/assets/logo.svg" @click="onLogoClick" />

    <form
      @submit.prevent="submit"
      class="d-flex flex-column mt-auto mb-6 form"
      novalidate
      autocomplete="off"
    >
      <v-text-field
        :label="$t('programCode')"
        outlined
        class="flex-grow-0 mb-2"
        dense
        type="email"
        v-model="roomName"
        color="primary"
        :error-messages="roomNameErrors"
      ></v-text-field>

      <v-btn
        color="primary"
        class="align-self-center"
        depressed
        type="submit"
        :loading="loader"
        :disabled="!isSupported"
      >
        {{ $t('programStart') }}
      </v-btn>
    </form>

    <v-btn @click="dialog = true" class="mb-6" :disabled="!isSupported">
      {{ $t('imageAndSoundCheck') }}
    </v-btn>

    <v-alert dense text type="error" v-if="!isSupported">
      {{ $t('browserNotSupported') }}
    </v-alert>

    <v-alert dense text type="warning" v-if="cameraPermission == 'denied'">
      {{ $t('cameraPermissionDenied') }}
    </v-alert>

    <v-alert dense text type="warning" v-if="micPermission == 'denied'">
      {{ $t('microphonePermissionDenied') }}
    </v-alert>

    <div class="body-2 mt-auto">
      {{ $t('viewList') }}
      <a class="font-weight-medium text-decoration-underline primary--text">{{ $t('frequentIssues') }}</a>
      {{ $t('contactSupport') }}
      <a class="font-weight-medium" href="mailto:support@museotek.net">support@museotek.net</a>
    </div>

    <v-dialog v-model="dialog" max-width="700px">
      <CheckTracks v-if="dialog" @close="dialog = false" />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import { isSupported } from "twilio-video";
import CheckTracks from "@/views/CheckTracks";

export default {
  components: {
    CheckTracks,
  },
  data() {
    return {
      roomName: "",
      loader: false,
      isSupported,
      dialog: false,
    };
  },
  validations: {
    roomName: { required },
  },
  computed: {
    ...mapState({
      cameraPermission: (state) => state.base.cameraPermission,
      micPermission: (state) => state.base.micPermission,
    }),
    roomNameErrors() {
      const errors = [];
      if (!this.$v.roomName.$dirty) return errors;
      if (!this.$v.roomName.required)
        errors.push(this.$t('fieldRequired'));
      return errors;
    },
  },
  methods: {
    ...mapActions(["connectToRoom"]),
    onLogoClick() {
      window.open("http://www.museotek.net");
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      try {
        this.loader = true;
        await this.connectToRoom(this.roomName);
        this.loader = false;
        this.$router.replace({ path: "/room" });
      } catch (e) {
        this.loader = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  height: 30px;
  cursor: pointer;
}

.form {
  width: 400px;
}
</style>
